import React from 'react';
import { useToken } from '../../hooks/TokenStorage';
import Login from '../pages/Login';


interface IAuthorizationProps {
    children: any
}

function Authorization({ children }: IAuthorizationProps) {
    const { token } = useToken();

    if (!token) return <Login />

    return children;
}

export default Authorization;
